
import { CREATE_USER_FORM_PROGRAM_DISCOUNT, FETCH_PROGRAM_DISCOUNT_DATA_FAILURE, FETCH_PROGRAM_DISCOUNT_DATA_REQUEST, FETCH_PROGRAM_DISCOUNT_DATA_SUCCESS, PROGRAM_DISCOUNT_USERFORM_RESET } from "./programDiscount.actionType";
export const PROGRAM_DISCOUNT = 'ProgramDiscount';

let initialState = {
    loading: false,
    userform: {
        startDate: new Date().setDate(new Date().getDate() - 15),
        endDate: new Date(),
        fldFKProgram: 0,
        fldProgram: ''
    },
    programDiscountData: [],
};

export let programDiscountReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;

    switch (type) {
        case FETCH_PROGRAM_DISCOUNT_DATA_REQUEST:

            return {
                ...state,
                loading: true
            };
        case FETCH_PROGRAM_DISCOUNT_DATA_SUCCESS:
            return {
                ...state,
                loading: false,
                programDiscountData: updatePayload.PDS
            };
        case CREATE_USER_FORM_PROGRAM_DISCOUNT:
            return {
                ...state,
                loading: false,
                userform: {
                    ...state.userform,
                    [payload.key]: payload.value
                }

            };
        case PROGRAM_DISCOUNT_USERFORM_RESET:
            return {
                ...state,

                userform: {
                    startDate: new Date().setDate(new Date().getDate() - 15),
                    endDate: new Date(),
                    fldFKProgram: 0,
                    fldProgram: ''
                }
            };
        case FETCH_PROGRAM_DISCOUNT_DATA_FAILURE:
            return {
                ...state,
                loading: false,
            };
        default:
            return state;
    }
}
